import { Controller } from "stimulus"

export default class extends Controller {
    static targets = ["link", "section"]

    connect() {
        this.observer = new IntersectionObserver(this.onIntersection.bind(this), {
            rootMargin: "-20% 0px -75% 0px"
        })

        this.sectionTargets.forEach(section => {
            this.observer.observe(section)
        })
    }

    disconnect() {
        this.observer.disconnect()
    }

    scrollTo(event) {
        event.preventDefault()
        const targetId = event.currentTarget.getAttribute("href").substring(1)
        const targetSection = document.getElementById(targetId)

        if (targetSection) {
            const headerOffset = 20 // Adjust based on sticky header height if needed
            const elementPosition = targetSection.getBoundingClientRect().top
            const offsetPosition = elementPosition + window.pageYOffset - headerOffset - 20

            window.scrollTo({
                top: offsetPosition,
                behavior: "smooth"
            })

            // Update URL hash without jumping
            history.pushState(null, null, `#${targetId}`)
        }
    }

    onIntersection(entries) {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                this.activateLink(entry.target.id)
            }
        })
    }

    activateLink(id) {
        this.linkTargets.forEach(link => {
            link.classList.remove("is-active")
            if (link.getAttribute("href") === `#${id}`) {
                link.classList.add("is-active")
            }
        })
    }
}
